import React, { useState } from 'react'
import CollectionsMenu from './CollectionsMenu'
import CollectionsContent from './CollectionsContent'
import EmailsContent from './EmailsContent'
import { Collection } from '../../../types/contentManagement'
import { collections } from './collectionsData'
import { emails } from './emailsData'
import { Flex, useBreakpointValue } from '@chakra-ui/react'

const ContentManagement = () => {
  const [selectedCollection, setSelectedCollection] = useState<Collection>(
    collections[0]
  )
  const [selectedEmailKey, setSelectedEmailKey] = useState<string | null>(null)
  const isMobile = useBreakpointValue({ base: true, md: false }) ?? false

  const handleCollectionChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedEmailKey(null)
    const collection =
      collections.find((col) => col.name === event.target.value) ||
      collections[0]
    setSelectedCollection(collection)
  }

  const handleSelectCollection = (collection: Collection) => {
    setSelectedEmailKey(null)
    setSelectedCollection(collection)
  }

  const handleEmailSelect = (key: string) => {
    setSelectedEmailKey(key)
  }

  const selectedEmail = emails.find((e) => e.key === selectedEmailKey) ?? null

  return (
    <Flex direction={{ base: 'column', md: 'row' }} p={4} h='82vh'>
      <CollectionsMenu
        collections={collections}
        selectedCollection={selectedCollection}
        handleCollectionChange={handleCollectionChange}
        setSelectedCollection={handleSelectCollection}
        isMobile={isMobile}
        emails={emails}
        selectedEmailKey={selectedEmailKey}
        onEmailSelect={handleEmailSelect}
      />
      {selectedEmail ? (
        <EmailsContent email={selectedEmail} />
      ) : (
        <CollectionsContent collection={selectedCollection} />
      )}
    </Flex>
  )
}

export default ContentManagement
